import styled from "styled-components";

interface MenuItem {
  icon: JSX.Element;
  title: string;
  isActive: boolean;
  path: string;
}

interface IPopMenu {
  menuItems: MenuItem[];
  onClickHandlers?: Array<() => void>;
  onClickTable?: (path: string) => void;
}

export default function PopMenu({
  menuItems,
  onClickHandlers = [],
  onClickTable,
}: IPopMenu) {
  return (
    <Container>
      {menuItems.map((item, index) => (
        <ButtonMenu
          key={index}
          isActive={item.isActive}
          onClick={() => onClickTable && onClickTable(item.path)}
        >
          {item.icon}
          <Description isActive={item.isActive}>{item.title}</Description>
        </ButtonMenu>
      ))}
    </Container>
  );
}

const Container = styled.main`
  position: absolute;
  z-index: 2;
  margin-top: 5px;
  background-color: ${(props) => props.theme.colors.white};
  box-shadow: 0px 2px 2px 0px ${(props) => props.theme.colors.gray.gray_100};
  border-radius: 4px;
  padding: 5px 3px;
  `;

const ButtonMenu = styled.button<{ isActive: boolean }>`
  width: 100%;
  padding: 5px 10px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${(props) => (props.isActive ? props.theme.colors.error : props.theme.colors.gray.gray_800)};
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 4px;
  font-size: 16px;
  text-align: start;

  &:hover {
    background-color: ${(props) => props.theme.colors.gray.gray_50};
    border-left: 2px solid ${(props) => props.theme.colors.primary};
    padding-left: 8px;
    color: ${(props) => props.theme.colors.primary};
  }
`;

const Description = styled.p<{ isActive: boolean }>`
  color: ${(props) => (props.isActive ? props.theme.colors.error : props.theme.colors.gray.gray_800)};
  font-size: 14px;

`;
